import { render, staticRenderFns } from "./AddProfilModal.vue?vue&type=template&id=30d8503a&"
import script from "./AddProfilModal.vue?vue&type=script&lang=ts&"
export * from "./AddProfilModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports